import React from "react";
import { fmtDisplayDate } from "../utils";

// ─── CommitmentList ─────────────────────────────────────────────────────────────
// Promises made about this work. Overdue commitments render as a red signal on
// the card. The commitment's `condition` is a real person's words (spec §3).
const CommitmentList = ({ commitments }) => {
  if (!commitments || commitments.length === 0) return null;

  return (
    <div className="px-5 py-3 border-b border-gray-200 dark:border-gray-800">
      <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 mb-2">
        Commitments
      </p>
      <div className="space-y-2">
        {commitments.map((c, i) => {
          const isOverdue = c.overdue || (c.due && new Date(c.due) < new Date());
          return (
            <div
              key={c.id || i}
              className={`flex items-start gap-2 px-2 py-1.5 rounded ${
                isOverdue ? "bg-red-50 dark:bg-red-900/20" : ""
              }`}
            >
              <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 mt-1.5 ${
                isOverdue ? "bg-red-500" : "bg-green-400"
              }`} />
              <div className="flex-1 min-w-0">
                <p className={`text-sm ${isOverdue ? "text-red-700 dark:text-red-400" : "text-gray-700 dark:text-gray-300"}`}>
                  {c.condition || c.text || "Promise"}
                </p>
                {c.due && (
                  <p className="text-xs text-gray-400 dark:text-gray-500 mt-0.5">
                    {isOverdue ? "Was due" : "Due"} {fmtDisplayDate(c.due)}
                  </p>
                )}
                {c.owner && (
                  <p className="text-xs text-gray-400 dark:text-gray-500">
                    {c.owner}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CommitmentList;
